<template>
  <div class="position-relative">
    <div class="container-fluid bg-white" id="header">
      <div class="row py-2 py-md-4">
        <div class="col-6 col-md-2">
          <a href="https://www.jobnet.ag" title="Zur Startseite dieses Angebotes" target="_top">
            <img :src="require('@/assets/img/logo/logo-jnjts.svg')" alt="logo" title="Zurück zur Startseite"
                 class="img-fluid">
          </a>
        </div>
        <div class="col-6 col-md-10 position-relative">
          <ul class="ms-0 d-md-flex list-inline float-end d-none lh-1 fw-bold align-items-center text-uppercase"
              style="font-size:0.80rem;">
            <li class="list-inline-item py-1 pe-1 d-none d-xxl-block"><a class="text-black-50"
                                                                         :href="`${site}/JobnetAG/Standorte/`" title="Standorte"
                                                                         target="_blank" lang="de"
                                                                         hreflang="de">Standorte</a></li>
            <li class="list-inline-item py-1 pe-1 d-none d-xxl-block"><a class="text-black-50"
                                                                         :href="`${site}/JobnetAG/Newsletter/`"
                                                                         title="Abonnieren Sie unseren Newsletter"
                                                                         target="_blank" lang="de" hreflang="de">Newsletter</a>
            </li>
            <li class="list-inline-item py-1 pe-1 d-none d-xxl-block"><a class="text-black-50"
                                                                         :href="`${site}/JobnetAG/Karriere/`" title="Karriere"
                                                                         target="_blank" lang="de"
                                                                         hreflang="de">Karriere</a></li>
            <li class="list-inline-item py-1 pe-1 d-none d-xxl-block"><a class="text-black-50" :href="`${site}/JobnetAG/Kontakt/`"
                                                                         title="Sie erreichen und per Telefon unter 030.5770012-0 oder per E-Mail unter info@jobnet.ag. Sie können auch das hier verlinkte Formular benutzen."
                                                                         target="_blank" lang="de"
                                                                         hreflang="de">Kontakt</a></li>
            <li class="list-inline-item py-1 pe-1 d-none d-xxl-block"><a class="text-black-50"
                                                                         :href="`${site}/JobnetAG/Kontakt/Support-Webinare.php`"
                                                                         title="Support/Webinare" target="_blank"
                                                                         lang="de" hreflang="de">Support/Webinare</a>
            </li>
            <li class="list-inline-item border rounded p-1">
              <b-icon icon="headset" class="me-1" />
              <a class="text-portal-primary" href="mailto:hotline@jobnet.solutions"
                 title="Kontakt mit der Hotline per E-Mail aufnehmen">hotline@jobnet.solutions</a>
              <span :class="`fi fis fi-de2  ms-2 me-1`"></span>
              <a href="tel:+4930577001255">+49.30.5770012-55</a>
              <span :class="`fi fis fi-at  ms-2 me-1`"></span>
              <a href="tel:+4317481010">+43.1.7481010</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <button class="btn btn-primary d-inline-block d-lg-none me-4 mt-3 fs-1 px-1 py-1 position-fixed top-0 end-0 border-3 border-white rounded-2" style="z-index:1042;" type="button" v-b-toggle.mobile-navigation-sidebar>
      <b-icon icon="list" />
    </button>
    <div class="container-fluid d-none d-lg-block" id="mainnavi">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <ul class="d-flex flex-nowrap my-0 fs-6 ps-0">
              <li class="flex-fill p-0 position-relative" v-for="(item, index) in navigation" :key="index">
                <a class="d-block p-2" target="_blank" :href="item.url" :title="item.title" v-html="item.title"></a>
                <b-icon v-if="item.child" icon="chevron-down" class="text-white position-absolute top-50 end-0 translate-middle-y me-2 d-none d-xl-block" />
                <ul class="position-absolute ps-0" v-if="item.child">
                  <li class="ps-0 pt-0 pb-0 pe-4 position-relative" v-for="(sub1, sub1index) in item.child" :key="sub1index">
                    <a class="d-block p-2 lh-sm" target="_blank" :href="sub1.url" :title="sub1.title">
                      {{sub1.title}}
                      <span class="fs-7 lh-sm fw-light d-block" v-if="sub1.description">{{sub1.description}}</span>
                    </a>
                    <b-icon v-if="sub1.child" icon="chevron-right" class="position-absolute top-50 end-0 translate-middle-y" />
                    <ul class="position-absolute ps-0" v-if="sub1.child">
                      <li class="ps-0 pt-0 pb-0 pe-4 position-relative"  v-for="(sub2, sub2index) in sub1.child" :key="sub2index">
                        <a class="d-block px-2 py-1 lh-sm" target="_blank" :href="sub2.url" :title="sub2.title">{{sub2.title}}</a>
                        <b-icon v-if="sub2.child" icon="chevron-right" class="position-absolute top-50 end-0 translate-middle-y" />
                        <ul v-if="sub2.child" class="position-absolute ps-0">
                          <li class="ps-0 pt-0 pb-0 pe-4 position-relative" v-for="(sub3, sub3index) in sub2.child" :key="sub3index">
                            <a class="d-block px-2 py-1 lh-sm" target="_blank" :href="sub3.url">{{sub3.title}}</a>
                          </li>
                        </ul>
                      </li>
                    </ul>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <MobileNavigationSidebar :navigation="navigation" />
  </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
import LanguageHeader from '@/components/Header/LanguageHeader.vue';
import { AppModule } from '@/store/modules/app';
import { getByDomain } from '@/config/sites';
import MobileNavigationSidebar from '@/components/Themes/MobileNavigationSidebar.vue';

import { navigation } from '@/config/navigation';

@Component({
  components: {
    MobileNavigationSidebar,
  },
})
export default class HeaderInformationNavigation extends Vue {
  get translations() {
    return AppModule.translation;
  }

  get lang() {
    return 'de';// AppModule.language;
  }

  get site() {
    const ThemeDetection = getByDomain();
    if (ThemeDetection && ThemeDetection.site) {
      return ThemeDetection.site;
    }
    return 'https://www.jobnet.ag';
  }

  get navigation() {
    return navigation;
  }
}
</script>
<style scoped lang="scss">
[theme="default"] {
  #header {
    .fw-bold {
      font-weight: 700 !important;
    }
  }

}

@media (min-width: 992px) {
  .container-fluid {
    padding-left: 2vw;
    padding-right: 2vw;
  }
}
</style>
